import type { CaptionListenerApi, AppStartListening } from '../helpers/types';

import { setDeafStatus } from 'features/call/call-deaf/store';
import { isAnyHearingConnectedSelector } from 'features/call/call-hearing/store';
import {
  clearCaptions,
  setCaptionRequest,
  stopCaptionsSessionThunk,
} from 'features/call/call-captions/store';

// String action types — .fulfilled creator imports break when thunks are mocked.
const hearingDisconnectFulfilledTypes = [
  'callHearing/notifyParticipantDisconnected/fulfilled',
  'call-hearing/disconnectById/fulfilled',
  'call-hearing/disconnectedFromCall/fulfilled',
] as const;

const isHearingDisconnectFulfilled = (action: { type: string }) =>
  hearingDisconnectFulfilledTypes.includes(
    action.type as (typeof hearingDisconnectFulfilledTypes)[number]
  );

// Hearing disconnect clears displayed lines only. It does not stop ASR.
const clearCaptionsIfNoHearingRemains = (api: CaptionListenerApi) => {
  if (isAnyHearingConnectedSelector(api.getState())) {
    return;
  }

  api.dispatch(clearCaptions());
};

const dropDeafCaptionRequest = (api: CaptionListenerApi) => {
  api.dispatch(
    setCaptionRequest({ requester: 'deafEndpoint', enabled: false })
  );
};

export const registerCaptionDisconnectListeners = (
  startListening: AppStartListening
) => {
  startListening({
    predicate: isHearingDisconnectFulfilled,
    effect: async (_action, api) => {
      clearCaptionsIfNoHearingRemains(api);
    },
  });

  // Drop deaf endpoint demand when they leave. Stop keeps ASR up if a VI
  // requester remains.
  startListening({
    actionCreator: setDeafStatus,
    effect: async (action, api) => {
      if (action.payload !== 'disconnected') {
        return;
      }

      dropDeafCaptionRequest(api);
      await api.dispatch(
        stopCaptionsSessionThunk({ source: 'deaf-disconnect' })
      );
    },
  });
};
